class Theme14plusContactPage {
  constructor(form) {
    this.form = form;
    this.submitButton = form.querySelector('[type="submit"]');
    this.fields = [
      {
        input: form.querySelector('#ContactForm-name'),
        validate: (input) => input.validity.valueMissing,
      },
      {
        input: form.querySelector('#ContactForm-email'),
        validate: (input) => input.validity.valueMissing || input.validity.typeMismatch,
      },
      {
        input: form.querySelector('#ContactForm-body'),
        validate: (input) => input.validity.valueMissing,
      },
    ].filter((field) => field.input);

    if (!this.fields.length) {
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    const handleValidation = (event) => {
      const firstInvalidField = this.validateFields();

      if (firstInvalidField) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        firstInvalidField.focus();
      }
    };

    if (this.submitButton) {
      this.submitButton.addEventListener('click', handleValidation, true);
    }

    this.fields.forEach(({ input }) => {
      input.addEventListener('input', () => {
        if (input.validity.valid) {
          this.clearFieldError(input);
        }
      });
    });
  }

  validateFields() {
    let firstInvalidField = null;

    this.fields.forEach(({ input, validate }) => {
      if (validate(input)) {
        this.setFieldError(input);
        firstInvalidField = firstInvalidField || input;
      } else {
        this.clearFieldError(input);
      }
    });

    return firstInvalidField;
  }

  setFieldError(input) {
    input.setAttribute('aria-invalid', 'true');
    input.closest('.field')?.classList.add('field--with-error');
  }

  clearFieldError(input) {
    input.removeAttribute('aria-invalid');
    input.closest('.field')?.classList.remove('field--with-error');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.theme14plus-contact-page__form')
    .forEach((form) => new Theme14plusContactPage(form));
});
